import type { FirstRechargeStagedSnapshot } from "@/modules/firstRechargeStaged/types";
import type { User } from "@/modules/user/types";
import {
  pickFirstRechargePromoRatio,
  pickFirstRechargePopupShowPercent,
} from "@/modules/user/firstRechargePromoFields";

/** 与首充分批浮标/弹窗：后台为手动分批且展示 UI 开关打开 */
export function isStagedFirstDepositUiEnabled(
  snapshot: FirstRechargeStagedSnapshot | null | undefined
): boolean {
  if (!snapshot) return false;
  return (
    snapshot.firstDepositMode === "STAGED_MANUAL" && !!snapshot.showStagedUi
  );
}

/**
 * 旧首充营销浮标 / 弹窗资格（金额或百分比），与 guest_info 等字段兼容（见 firstRechargePromoFields）。
 */
export function qualifiesLegacyFirstRechargePopup(
  userInfo: User | null
): boolean {
  if (!userInfo || userInfo.firstRechargeFlag) return false;

  const amountOk = (userInfo.firstRechargeRuleAmount ?? 0) > 0;
  const r = pickFirstRechargePromoRatio(userInfo);
  const n = r != null ? Number(r) : NaN;
  const ratioOk = Number.isFinite(n) && n > 0;

  const showPercentFlag = pickFirstRechargePopupShowPercent(userInfo);
  if (showPercentFlag === false && !ratioOk) {
    return amountOk;
  }

  if (ratioOk) return true;
  return amountOk;
}

/** 手动分批且展示开关打开时，旧首充营销让路给分批 */
export function hideLegacyFirstRechargeForStaged(
  snapshot: FirstRechargeStagedSnapshot | null | undefined
): boolean {
  return (
    snapshot?.firstDepositMode === "STAGED_MANUAL" && !!snapshot?.showStagedUi
  );
}
